import { Injectable } from '@angular/core';
import { Observable, throwError, Subject } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Settings } from './settings';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ModelMessageComponent } from '../components/model-message/model-message.component';

@Injectable({
    providedIn: 'root'
  })
export class GlobalService {

	public globalEvent = new Subject();
	public dialogRef = null;   
	constructor(public dialog: MatDialog) {
			
    }
    
    openDialog() {
	    this.dialogRef = this.dialog.open(ModelMessageComponent, {ariaModal: true, disableClose: true});
	}
	closeDialog() {
		this.dialogRef.close()
	}
}
